import React from 'react'
import { useStore } from 'app/store'

type Props = {
  scopes?: string[]
  children: any
}

export const usePermissionGate = () => {
  const { dashboard } = useStore()
  const isScopesGranted = (scopes?: string[]) => {
    return scopes?.every((scope) => dashboard.permissions[scope]) ?? true
  }

  return {
    isScopesGranted,
  }
}

function PermissionsGate({ scopes, children }: Props) {
  const { isScopesGranted } = usePermissionGate()
  const isAllowed = isScopesGranted(scopes)
  if (!isAllowed) return null
  return children
}

export default PermissionsGate
